import * as angular from "angular";
import { Group } from "../../models/group.model";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { GroupDataProvider } from "../../data-provider/group.dp";

let TeamAssignComponent = {
    selector: "vcTeamAssign",
    templateUrl: "/angular/components/group/team-assign.component.html",
    bindings: {
        group: "=",
    },
    controller: class TeamAssignController {
        // * bindings for typescript compiler *
        public group: Group;
        // ************************************
        public editgroup: Group;
        public teams: any[];

        private dialog: DialogUtils;
        private toast: ToastUtils;
        private modelsUtils: any;
        private dataProvider: GroupDataProvider;

        private loading: boolean;
        private readonly $scope: any;
        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ModelsUtils: any,
            TeamDataProvider: TeamDataProvider,
            GroupDataProvider: GroupDataProvider
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.modelsUtils = ModelsUtils;

            this.dataProvider = GroupDataProvider;

            TeamDataProvider.getAllTeams().then((teams: object[]) => {
                this.teams = teams;
            });
        }

        $onInit() {
            this.editgroup = this.modelsUtils.group(this.group);
        }

        saveAutoSplitAssign(): void {
            this.loading = true;

            this.editgroup.update().then((group: Group) => {
                this.toast.success("Auto Split Team Assigned");
                this.dialog.hide(group);
                this.loading = false;
            });
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("group")
    .component(TeamAssignComponent.selector, TeamAssignComponent);
